import { TableRow } from '@mui/material';

import { TableBodySkeleton, RowTableCell } from '../../../../common/components';

const TableStateRow = ({ colSpan, loading, emptyMessage }) => {
  if (loading) {
    return <TableBodySkeleton />;
  }

  return (
    <TableRow>
      <RowTableCell colSpan={colSpan} sx={{ textAlign: 'center', py: 3 }}>
        {emptyMessage}
      </RowTableCell>
    </TableRow>
  );
};

export default TableStateRow;
